import { Component } from '@angular/core';

import {classes} from "../classes";
import {Lesson, lessons} from "../lessons";

@Component({
    selector: 'app-class-list',
    templateUrl: './class-list.component.html',
    styleUrls: ['./class-list.component.css']
})
export class ClassListComponent {
    classes = classes;
    thisSunday = this.getSunday(new Date());
    nextSunday = this.getSunday(this.getNextWeek(new Date()));
    thisWeekNumber = this.getSundayWeekNumber(this.thisSunday);
    nextWeekNumber = this.getSundayWeekNumber(this.nextSunday);
    thisWeekClasses = classes
        .filter(c=> {return (c.weeks.indexOf(this.thisWeekNumber) >= 0)})
        .map(c=> {c.lesson = this.getLesson(this.thisSunday, c.name);
                return c});
    nextWeekClasses = classes
        .filter(c=> {return (c.weeks.indexOf(this.nextWeekNumber) >= 0)})
        .map(c=> {c.lesson = this.getLesson(this.nextSunday, c.name);
            return c});
    showNextWeek = false;
    showThisWeek = true;
    
    toggleNextWeek(): void {
        this.showNextWeek = !this.showNextWeek;
    }
    toggleThisWeek(): void {
        this.showThisWeek = !this.showThisWeek;
    }
    
    public getSundayWeekNumber(date: Date): number {
        const sunday = this.getSunday(date);
        return this.getWeekNumber(sunday);
    }

    private getSunday(date: Date) {
        return this.getNextDayOfTheWeek('sunday', false, date);
    }

    private getNextDayOfTheWeek(dayName: string, excludeToday = false, refDate = new Date()): Date {
        const dayOfWeek = ["sun","mon","tue","wed","thu","fri","sat"]
            .indexOf(dayName.slice(0,3).toLowerCase());
        if (dayOfWeek < 0) return refDate;
        refDate.setHours(0,0,0,0); // sorry, doesn't do timezones
        refDate.setDate(refDate.getDate() + +!!excludeToday +
            (dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7);
        return refDate;
    }

    private getWeekNumber(date: Date): number {
        return Math.floor((date.getDate() -1) / 7) + 1;
    }

    private getNextWeek(date: Date): Date {
        date.setDate(date.getDate() + 7);
        return date;
    }
    
    private getLesson(date: Date, className: string): Lesson | undefined {
        const lesson = lessons.find(l => l.className === className && new Date(l.date).getTime() == date.getTime());
        return lesson;
    }
}

